import { render, staticRenderFns } from "./rockiot.ui.attributes.vue?vue&type=template&id=0f638134"
import script from "./rockiot.ui.attributes.vue?vue&type=script&lang=js"
export * from "./rockiot.ui.attributes.vue?vue&type=script&lang=js"
import style0 from "./rockiot.ui.attributes.vue?vue&type=style&index=0&id=0f638134&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports